const SVGIconFile = () => (
    <svg
        height="20px"
        width="20px"
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 309.267 309.267"
        fill="#000000"
    >
        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
        <g id="SVGRepo_iconCarrier">
            <g>
                <path
                    style={{
                        fill: "#E4E7E7",
                    }}
                    d="M38.658,0h164.23l87.049,86.711v203.227c0,10.679-8.659,19.329-19.329,19.329H38.658 c-10.67,0-19.329-8.65-19.329-19.329V19.329C19.329,8.65,27.989,0,38.658,0z"
                ></path>
                <path
                    style={{
                        fill: "#C2C5C7",
                    }}
                    d="M289.658,86.981h-67.372c-10.67,0-19.329-8.659-19.329-19.329V0.193L289.658,86.981z"
                ></path>
                <path
                    style={{
                        fill: "#CCD0D2",
                    }}
                    d="M57.988,125.64v19.329H251.28V125.64H57.988z M57.988,183.637H251.28v-19.329H57.988V183.637z M57.988,222.286H251.28v-19.329H57.988V222.286z M57.988,260.944H251.28v-19.32H57.988V260.944z M164.298,86.981H57.988v19.329 h106.311L164.298,86.981L164.298,86.981z M164.298,48.323H57.988v19.329h106.311L164.298,48.323L164.298,48.323z"
                ></path>
            </g>
        </g>
    </svg>
);

export default SVGIconFile;